<template>
  <main class="settings-page">
    <div class="settings-page__heading">
      <h1>{{ $t('settings.title') }}</h1>
      <p class="text-muted mb-0">
        {{ $t('settings.description') }}
      </p>
    </div>

    <b-row>
      <b-col
        md="3"
        xl="2"
        class="mb-3">
        <b-list-group>
          <b-list-group-item
            v-for="section in sections"
            :key="section.key"
            :active="section.key === currentSection.key"
            :to="`/administration/settings/${section.key}`"
            class="settings-page__nav-item">
            <v-icon :name="section.icon" />
            {{ $t(`settings.sections.${section.key}.title`) }}
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col
        md="9"
        xl="10">
        <component
          :is="currentSection.component"
          :key="currentSection.key" />
      </b-col>
    </b-row>
  </main>
</template>

<script>
import allSections from './sections';

export default {
  computed: {
    sections() {
      return allSections.filter(section => !section.isAllowed || section.isAllowed(this.$store));
    },
    currentSection() {
      return this.sections.find(section => section.key === this.$route.params.section) || this.sections[0];
    }
  },
  created() {
    if (!this.sections.length) {
      this.$router.replace('/404');
    }
  }
};
</script>

<style scoped>
.settings-page {
  padding: 1rem 1.5rem;
  text-align: left;
  width: 100%;
}

.settings-page__heading {
  margin-bottom: 1.5rem;
}

.settings-page__heading h1 {
  font-size: 1.5rem;
  margin-bottom: 0.25rem;
}

.settings-page__nav-item .fa-icon {
  margin-right: 0.5rem;
}
</style>
